import log from 'salvo-lite/log'
import Helpers from '../helpers/Helpers'

class NewsletterPopup {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._options = Object.assign({
            timeout: false
        }, JSON.parse(this._elem.dataset.newsletterPopup ? this._elem.dataset.newsletterPopup : '{}'))
        this._closeElems = this._elem.querySelectorAll('[data-close]')
        this._newsletterKey = 'ESC_NEWSLETTER_CLOSED'
        this._newsletterEpochKey = `${this._newsletterKey}_EPOCH`
        this._newsletterForm = this._elem.querySelector('form')
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        log.debug(this.constructor.name, 'Initiating', this)

        if (localStorage.getItem(this._newsletterEpochKey) && this._options.timeout !== false) {
            let time = localStorage.getItem(this._newsletterEpochKey)
            let currentTime = new Date().getTime()
            if (currentTime - time >= this._options.timeout) {
                localStorage.removeItem(this._newsletterKey)
                localStorage.removeItem(this._newsletterEpochKey)
            }
        }

        if (!localStorage.getItem(this._newsletterKey)) {
            setTimeout(() => {
                if (this._options.onExit && !Helpers.isTouchScreen()) {
                    this.exitEvent()
                } else {
                    this._elem.classList.add('shown')
                }
            }, this._options.delay)
        }

        for (let closeElem of this._closeElems) {
            closeElem.addEventListener('click', e => {
                e.preventDefault()
                this.closePopup()
            })
        }

        this._elem.addEventListener('click', e => {
            if (e.target === this._elem) {
                e.preventDefault()
                this.closePopup()
            }
        })

        this._newsletterForm.addEventListener('submit', e => {
            localStorage.setItem(this._newsletterKey, true)
            localStorage.setItem(this._newsletterEpochKey, new Date().getTime())
        })

        document.addEventListener('shopify:section:deselect', e => {
            if (e.detail.sectionId === this._options.sectionId) {
                this._elem.classList.remove('shown')
            }
        })

        document.addEventListener('shopify:section:select', e => {
            if (e.detail.sectionId === this._options.sectionId) {
                this._elem.classList.add('shown')
            }
        })

        log.debug(this.constructor.name, 'Initiated', this)
    }

    exitEvent () {
        document.addEventListener('mouseout', e => {
            let from = e.relatedTarget || e.toElement
            if ((!from || from.nodeName === 'HTML') && !localStorage.getItem(this._newsletterKey)) {
                this._elem.classList.add('shown')
            }
        })
    }

    closePopup () {
        localStorage.setItem(this._newsletterKey, true)
        localStorage.setItem(this._newsletterEpochKey, new Date().getTime())
        this._elem.classList.remove('shown')
    }
}

export default NewsletterPopup



// WEBPACK FOOTER //
// ./src/resources/scripts/components/NewsletterPopup.js